import React from 'react';

import Content from '@components/Dashboard/AdminPanel/StoreMigration';

const StoreMigration: React.FC = () => {
  return <Content />;
};

export default StoreMigration;
